import {apiUrl, apiOption, apiResponse} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'
import {Audit} from './models'

const NAMESPACE = 'Audit'
export const REPORT_STREAM_LOADED = NAMESPACE + '/ReportSteamLoaded'

export function loadReportStream(query) {
    return loading(fetch(apiUrl(config.audit.api.url + '/reports', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: REPORT_STREAM_LOADED,
            stream: json.result.sort((a, b) => new Date(a.created) - new Date(b.created)),
            stats: {
            	newAudits: {
            		currentYear: Audit.yearlyAuditCount(json.result)
            	}
            }
        }
    }), REPORT_STREAM_LOADED)
}


// WEBPACK FOOTER //
// ./lib/audit/actions.js